<nb-card>
  <nb-card-header>
    <h6 i18n="@@ConfirmAction">Подтвердите действие</h6>
  </nb-card-header>
  <nb-card-body>
    {{ description }}
  </nb-card-body>
  <nb-card-footer>
    <button nbButton [status]="confirmStatus" (click)="dismiss(true)" i18n="@@Ok">OK</button>
    &nbsp;
    <button nbButton status="basic" (click)="dismiss(false)" i18n="@@Cancel">Отмена</button>
  </nb-card-footer>
</nb-card>
